<template>
        <div :class="`${($store.getters['display/getAside'])?'contents expanded':'contents'}`">

            <div class="container-fluid">
                <div class="social-dash-wrap">
                    <div class="row">
                        <div class="col-lg-12">

                            <div class="breadcrumb-main">
                                <h4 class="text-capitalize breadcrumb-title">Dashboard</h4>
           
                            </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="card-body">
                                    <p class="color-dark fw-500 fs-20 mb-0">Welcome Dashboard</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
</template>

<script>
// @ is an alias to /src

import * as serviceAPI  from '../services/API.service';
// import { lightFormat } from 'date-fns'
export default {
  name: 'Welcome',
  data: function () {
    return {

      }
    },
  mounted() {
      console.log("welcome page")
      console.log(this.$store.getters['auth/getloggedIn'])
  },
  methods: {
  },
//   computed: {
  	
//     showtime(){
//         return lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
//     }
//   }
}

</script>